// src/services/LoaderService.ts
type LoaderCallback = (visible: boolean) => void;

class LoaderService {
  private static listeners: LoaderCallback[] = [];

  static show() {
    this.listeners.forEach((cb) => cb(true));
  }

  static hide() {
    this.listeners.forEach((cb) => cb(false));
  }

  static subscribe(callback: LoaderCallback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter((cb) => cb !== callback);
    };
  }
}

export default LoaderService;
